import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setS3Settings = (state, { s3Settings }) => {
  if (!s3Settings) return state;
  return state.merge({ s3Settings });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_S3_SETTINGS,
    actionFunction: setS3Settings,
  },
];
